module.exports = __webpack_public_path__ + "media/fonts/typicons-6697a4a6203533fd919aa9cba7bbb57d.svg";